module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }